import {PermissionButtonOrg, TabHeader} from '@/ui/index'
import {Stack} from '@sanity/ui'
import {AddIcon} from '@sanity/icons'
import {Box} from '@sanity/ui'
import {TokensTable} from './TokensTable'
import {TokenCreationFormDialog} from './TokenCreationFormDialog'
import {useOrgTokens} from './queries'
import {useState} from 'react'

export function OrgTokensTab({description}: {title: string; description: string}) {
  const [addTokenDialogOpen, setAddTokenDialogOpen] = useState(false)
  const {data: tokens, isLoading} = useOrgTokens()

  const handleToggleAddToken = () => {
    setAddTokenDialogOpen((open) => !open)
  }

  return (
    <Box>
      <Stack space={4}>
        <TabHeader
          title={'Tokens'}
          description={description}
          button={
            <PermissionButtonOrg
              title="Add API token"
              icon={AddIcon}
              mode="ghost"
              onClick={handleToggleAddToken}
              permissions={[{permissionName: 'sanity.organization.tokens', grantName: 'create'}]}
              action="cannot add API tokens"
            />
          }
        />
        <TokensTable tokens={tokens?.data ?? []} loading={isLoading} />
        {addTokenDialogOpen && <TokenCreationFormDialog onClose={handleToggleAddToken} />}
      </Stack>
    </Box>
  )
}
